import React from 'react';
import styled from 'styled-components';

import { ReactComponent as Star } from 'src/iconic/star.svg';
import { $t } from 'src/utils';

const Container = styled.span`
  display: flex;
`;

/**
 * Shows set of 5 stars
 * Based on rating, fill or dont fill the icon
 * CMS requires "Not Rated" in place of a missing QRS rating
 */
const Rating = ({ rating }) => {
  const stars = Array.from(Array(5).keys());

  if (!rating || rating <= 0) {
    return (
      <Container>{$t({ id: 'health-plan.not-rated', defaultMessage: 'Not Rated' })}</Container>
    );
  }

  return (
    <Container>
      {stars.map((star) =>
        React.createElement(Star, {
          fill: star < rating ? '#FFD612' : 'var(--c-border)',
        }),
      )}
    </Container>
  );
};

export default Rating;
